import React, {use, useEffect, useState} from "react";
import { Accordion } from "react-bootstrap";
import { connect } from 'react-redux';
import {vtoConstants} from "../VTOConstants";
import { Button } from "react-bootstrap";
import "../VoluntaryTOffComponent.scss";
import strings from "../../../resources/strings.json";
import { getClassificationOptions, getDutyAssignmentOptions, handlePreviousPage, handleNextPage, handleLastPage, handleFirstPag, getStationTimestamp, validateOfferTimes, updateAllOfferErrors, setCutOffTime, buildOffersResponse, createSearchCriteria, isAfter2330, validateFields, getGroupOptions} from '../utils';
import { useHistory } from "react-router-dom";
import moment from "moment";
import DropdownSelect from "../DropdownSelect";
import NewOfferComponent from "./newOfferComponent";
import CurrentOffers from "./currentOffersComponent";
import flashIcon from "../../../assets/images/flash_icon.svg";
import infoIcon from "../../../assets/images/about_icon.svg";
import ConfirmationPopUp from "../confirmationPopUp";
import DuplicateOfferModal from "./modals/DuplicateOfferModal";
import SlotsSuccessModal from "./modals/SlotsSuccessModal";

const CreateOfferscreen = (props) => {
    const history = useHistory();

    const [availableDates, setAvailableDates] = useState([
            moment().format('MM/DD/YYYY'),
            moment().add(1, 'days').format('MM/DD/YYYY'),
            moment().add(2, 'days').format('MM/DD/YYYY')
    ]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [dateShown, setDateShown] = useState("");
    const [isFlashOffer, setIsFlashOffer] = useState(false);
    const [selectedStation, setSelectedStation] = useState("");
    const [stationOptions, setStationOptions ] = useState(props.stationList? props.stationList: []);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [departmentOptions, setDepartmentOptions ] = useState(['Customer Care', 'Customer Operations']);
    const [selectedDutyAssig, setSelectedDutyAssig ] = useState("");
    const [dutyAssigOptions, setDutyAssigOptions ] = useState([]);
    const [classificationOptions, setClassificationOptions ] = useState([]);
    const [selectedClassification, setSelectedClassification ] = useState("");
    const [selectedWorkLoc, setSelectedWorkLoc] = useState("");
    const [workLocOptions, setWorkLocOptions] = useState([]);
    const [isCheckedApplyAll, setisCheckedApplyAll] = useState(true);
    const [offerDetails, setOfferDetails] =useState({
            "id": 0,
            "offerEndTimeHr": "",
            "offerEndTimeMin": "",
            "offerStartTimeHr": "",
            "offerStartTimeMin": "",
            "duration": "",
            "slots":1,
            "error": false,
            "note": "",
            "classification":"",
            "dutyAssignment": "",
            "cdaError": false,
            "cutOffTime": {
                // "2/27/2025": {
                //     date: "2/27/2025",
                //     time: "",
                //     default: "",
                //     untilDepleted: true
                // },
                // "2/28/2025": {
                //     date: "2/27/2025",
                //     time: "",
                //     default: "",
                //     untilDepleted: true
                // }
            }
        });
    const [activeKey, setActiveKey] = useState(null);
    const [showCDAError, setShowCDAError] = useState(false);
    const [offersConsolidation, setOffersConsolidation] = useState({});
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] =useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsperPage, setItemsperPage] = useState(10);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showRequiredFieldsError, setShowRequiredFieldsError] = useState(false);
    const [showSubmitPopup, setShowSubmitPopup] = useState(false);
    const [offersSummary, setOffersSummary] = useState({});
    const [isStationError, setIsStationError] = useState(false);
    const [stationTime, setStationTime] = useState(null);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [duplicateOffers, setDuplicateOffers] = useState([]);
    const [duplicateResolutions, setDuplicateResolutions] = useState({});
    const [selectedOfferForSlots, setSelectedOfferForSlots] = useState(null);
    const [showSlotsSuccessModal, setShowSlotsSuccessModal] = useState(false);

const hasSelectionError = (offerId) => {
    let previousOffers = { ...offersConsolidation };
    let currentOffer = { ...offersConsolidation[offerId] };
    const todaySelected = selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"));

    if (offerId || offerId == "0") {
        if (!currentOffer.offerStartTimeHr || !currentOffer.offerStartTimeMin) {
            setValidationError(offerId, "Please select Start Time");
            return true;
        } else if (!currentOffer.offerEndTimeHr || !currentOffer.offerEndTimeMin) {
            setValidationError(offerId, "Please select End Time");
            return true;
        } else {
            if (todaySelected) {
                const now = stationTime;
                const minStartTime = moment(now).add(30, 'minutes');
                const startTime = moment(`${moment(now).format("MM/DD/YYYY")} ${currentOffer.offerStartTimeHr}:${currentOffer.offerStartTimeMin}`, "MM/DD/YYYY HH:mm");
                if (startTime.isBefore(now)) {
                    setValidationError(offerId, "Start time has already passed for today.");
                    return true;
                } else if (startTime.isBefore(minStartTime)) {
                    setValidationError(offerId, "Start time should be at least 30 minutes from now.");
                    return true;
                } else {
                    clearValidationError(offerId);
                    return false;
                }
            } else {
                clearValidationError(offerId);
                return false;
            }
        }
    }
    return;
}
    
    const handleAddNewOffer = (offer) =>{
        if ((activeKey || activeKey === "0")&&hasSelectionError(activeKey)) return
        if (activeKey!=null && Number(activeKey)>=0 && !isCheckedApplyAll && (!offersConsolidation[activeKey].classification || !offersConsolidation[activeKey].dutyAssignment)) {
            let previousOffers = {...offersConsolidation};
                let currentOffer = {...offersConsolidation[activeKey]};
                currentOffer.cdaError = true;
                setShowCDAError(true);
                previousOffers[activeKey] = currentOffer;
                setOffersConsolidation(previousOffers);
            return
        }
        if (activeKey&&offersConsolidation[activeKey].error) return;
            let currentCount = Object.keys(offersConsolidation).length > 0 ? Number(Object.keys(offersConsolidation)[Object.keys(offersConsolidation).length-1]) + 1 : 0;
            let currentOffers = {...offersConsolidation};
            offerDetails.id=currentCount;
            
            let newOffer = {
                "id": currentCount,
                "offerStartTimeHr": "",
                "offerStartTimeMin": "",
                "offerEndTimeMin": "",
                "offerEndTimeHr": "",
                "duration": "",
                "slots": 1,
                "error": false,
                "note": "",
                "classification": "",
                "dutyAssignment": "",
                "cdaError": false,
                "cutOffTime": selectedDates.reduce((acc, date) => {
                    acc[date] = setCutOffTime(date,stationTime);
                    return acc;
                }, {}),
            };
            setOfferDetails(newOffer)
            setOffersConsolidation({...currentOffers, [newOffer.id]: {...newOffer}});
            setActiveKey(currentCount.toString())
    }

    const handleDeleteOffer = (e) =>{
        hasSelectionError(activeKey)
        if (Object.keys(offersConsolidation).length == 0) return;
        let idToDelete = e.currentTarget.id;
        let updatedBatch = {...offersConsolidation};
        delete updatedBatch[idToDelete];
        if (idToDelete == activeKey) {
            setActiveKey(null);
        }
        setOffersConsolidation(updatedBatch);
        if (showError) {
            const stillHasError = Object.values(updatedBatch).some(offer => offer.error);
            if (!stillHasError) {
                setShowError(false);
            }
        }
        return
    }

    const handleClickHeader = (id) => {
        if (id.toString() === activeKey) {
            setActiveKey(null);
        } else {
            setActiveKey(id.toString());
        }
        return;
    }

    const handleSelectStation = async (station) => {
        setSelectedStation(station.toUpperCase());
        let stationTime = await getStationTimestamp(station.toUpperCase());
        setStationTime(stationTime);
        const stationTimeClean = typeof stationTime === 'string' ? stationTime.split('.')[0] : stationTime;
    const stationMoment = moment(stationTimeClean);
    const hour = stationMoment.hour();
    const minute = stationMoment.minute();
    const after2330 = hour > 23 || (hour === 23 && minute >= 30);
    const todayStr = moment().format('MM/DD/YYYY');
    if (after2330 && selectedDates.includes(todayStr)) {
        setSelectedDates(selectedDates.filter(date => date !== todayStr));
    }
        if (selectedDepartment.length>0) {
            setSelectedDepartment("")
        }
        if (selectedWorkLoc.length>0) {
            setSelectedWorkLoc("")
        }
    }

    const handleSelectDepartment = async (dpt) => {
        let classificationCodes = await getClassificationOptions(selectedStation.toUpperCase(),dpt);
        setClassificationOptions(classificationCodes);
        let dutyAssigCodes = await getDutyAssignmentOptions(selectedStation.toUpperCase(),dpt);
        setDutyAssigOptions(dutyAssigCodes);
        setSelectedDepartment(dpt);
    }

    const handleSelectDate = (date) => {
        let currentSelection = [...selectedDates];
        if (selectedDates.includes(date)) {
            if (Object.keys(offersConsolidation).length == 1 && selectedDates.length == 1) return;
            let idxToDelete = currentSelection.indexOf(date);
            currentSelection.splice(idxToDelete, 1);
            let updatedOffers = updateAllOfferErrors(offersConsolidation, currentSelection, stationTime);
            setOffersConsolidation(updatedOffers);
            setSelectedDates(currentSelection);
            setTimeout(() => {
                const errorOffer = Object.values(updatedOffers).find(offer => offer.error);
                if (errorOffer) {
                    setActiveKey(errorOffer.id.toString());
                } else {
                    setActiveKey(null);
                }
            }, 0);
        } else {
            let newDate = moment(date);
            const index = currentSelection.findIndex(existingDate => moment(existingDate) > newDate);
            if (index === -1) {
                currentSelection.push(newDate.format('MM/DD/YYYY'));
            } else {
                currentSelection.splice(index, 0, newDate.format('MM/DD/YYYY'));
            }
            if (Object.keys(offersConsolidation).length > 0) {
                const { updatedOffers, errorOfferId } = validateOfferTimes(offersConsolidation, newDate.format('MM/DD/YYYY'), null, stationTime);
                setOffersConsolidation(updatedOffers);
                setSelectedDates(currentSelection);
                if (errorOfferId !== null) {
                    setShowError(true);
                    setActiveKey(errorOfferId.toString());
                } else {
                    setShowError(false);
                    setActiveKey(null);
                }
            } else {
                setSelectedDates(currentSelection);
            }
            if (Object.keys(offersConsolidation).length > 0) {
                let previousOffers = { ...offersConsolidation };
                Object.values(previousOffers).forEach(offer => {
                    let currentOffer = { ...previousOffers[offer.id] };
                    currentOffer.cutOffTime[date] = setCutOffTime(date, stationTime);
                    previousOffers[offer.id] = currentOffer;
                });
                setOffersConsolidation(previousOffers);
            }
        }
    }

    const fillClassificationAndDutyA = () => {
        let previousOffers = {...offersConsolidation};

        Object.values(previousOffers).forEach(offer=> {
            let currentOffer = {...previousOffers[offer.id]};
            currentOffer.classification = selectedClassification;
            currentOffer.dutyAssignment = selectedDutyAssig;
            previousOffers[offer.id] = currentOffer;
            setShowCDAError(true);
        })
        
        setOffersConsolidation(previousOffers);
        return
    }

    const handleApplyAllChange = () => {
        if (selectedClassification && selectedDutyAssig) {
        fillClassificationAndDutyA()
        }
        setisCheckedApplyAll(!isCheckedApplyAll)
    }

    const resetDuplicateModalState = () => {
        setShowDuplicateModal(false);
        setDuplicateOffers([]);
        setDuplicateResolutions({});
    };

    const setValidationError = (offerId, errorMessage, offerError = null) => {
        if (offerId || offerId === "0") {
            let previousOffers = { ...offersConsolidation };
            let currentOffer = { ...offersConsolidation[offerId] };
            currentOffer.error = offerError || errorMessage;
            previousOffers[offerId] = currentOffer;
            setOffersConsolidation(previousOffers);
        }
        setErrorMessage(errorMessage);
        setShowError(true);
    };

    const clearValidationError = (offerId = null) => {
        if (offerId || offerId === "0") {
            let previousOffers = { ...offersConsolidation };
            let currentOffer = { ...offersConsolidation[offerId] };
            currentOffer.error = false;
            previousOffers[offerId] = currentOffer;
            setOffersConsolidation(previousOffers);
        }
        setShowError(false);
        setErrorMessage("");
    };

    const handleConfirmDuplicateResolutions = async () => {
        try {
            const offersToCreate = [];
            const slotsToUpdate = [];
            const offerIdsToRemove = [];
            
            duplicateOffers.forEach((duplicate, offerIndex) => {
                const offerResolutions = duplicateResolutions[offerIndex] || {};
                let hasSlotUpdates = false;
                let hasCreateDuplicates = false;
                
                duplicate.duplicateDates.forEach(duplicateDate => {
                    const resolution = offerResolutions[duplicateDate.date];
                    if (resolution?.action === 'addSlots') {
                        hasSlotUpdates = true;
                        slotsToUpdate.push({
                            offerId: duplicateDate.existingOffer.offerId,
                            additionalSlots: resolution.additionalSlots,
                            currentSlots: duplicateDate.existingOffer.slots || 0,
                            date: duplicateDate.date
                        });
                    } else if (resolution?.action === 'createDuplicate') {
                        hasCreateDuplicates = true;
                    }
                });
                
                if (hasSlotUpdates && (hasCreateDuplicates || duplicate.nonDuplicateDates.length > 0)) {
                    const datesToCreate = [
                        ...duplicate.duplicateDates
                            .filter(dup => offerResolutions[dup.date]?.action === 'createDuplicate')
                            .map(dup => dup.date),
                        ...duplicate.nonDuplicateDates
                    ];
                    
                    if (datesToCreate.length > 0) {
                        const modifiedOffer = {
                            ...duplicate.newOffer,
                            datesToCreate: datesToCreate
                        };
                        offersToCreate.push(modifiedOffer);
                    }
                } else if (hasSlotUpdates && !hasCreateDuplicates && duplicate.nonDuplicateDates.length === 0) {
                    offerIdsToRemove.push(duplicate.newOffer.id);
                } else if (!hasSlotUpdates) {
                    offersToCreate.push(duplicate.newOffer);
                }
            });
            
            let updatedOffersConsolidation = { ...offersConsolidation };
            duplicateOffers.forEach((duplicate, offerIndex) => {
                const offerResolutions = duplicateResolutions[offerIndex] || {};
                const datesWithSlotUpdates = [];
                
                duplicate.duplicateDates.forEach(duplicateDate => {
                    const resolution = offerResolutions[duplicateDate.date];
                    if (resolution?.action === 'addSlots') {
                        datesWithSlotUpdates.push(duplicateDate.date);
                    }
                });
                
                if (datesWithSlotUpdates.length > 0) {
                    const offerToUpdate = updatedOffersConsolidation[duplicate.newOffer.id];
                    if (offerToUpdate) {
                        const updatedCutOffTime = { ...offerToUpdate.cutOffTime };
                        datesWithSlotUpdates.forEach(date => {
                            delete updatedCutOffTime[date];
                        });
                        const remainingDates = selectedDates.filter(date => !datesWithSlotUpdates.includes(date));
                        if (remainingDates.length === 0) {
                            delete updatedOffersConsolidation[duplicate.newOffer.id];
                        } else {
                            updatedOffersConsolidation[duplicate.newOffer.id] = {
                                ...offerToUpdate,
                                cutOffTime: updatedCutOffTime
                            };
                        }
                    }
                }
            });
            
            offerIdsToRemove.forEach(offerId => {
                delete updatedOffersConsolidation[offerId];
            });
            
            setOffersConsolidation(updatedOffersConsolidation);
            if (slotsToUpdate.length > 0) {
                for (const slotUpdate of slotsToUpdate) {
                    const newSlotCount = slotUpdate.currentSlots + slotUpdate.additionalSlots;
                    
                    try {
                        const response = await props.updateSlotsRequest({
                            "offerId": slotUpdate.offerId,
                            "station": selectedStation,
                            "slots": newSlotCount
                        });
                    } catch (error) {
                        console.error(`Error updating slots for offer ${slotUpdate.offerId}:`, error);
                        alert(`Failed to update slots for offer ${slotUpdate.offerId}. Please try again.`);
                        return;
                    }
                }
            }
            
            if (offersToCreate.length > 0) {
                const response = buildOffersResponse(offersToCreate, selectedDates, selectedStation, selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig);
                setOffersSummary(response);
                resetDuplicateModalState();
                setShowSubmitPopup(true);
                return;
            }
            
            if (slotsToUpdate.length > 0 && offersToCreate.length === 0) {
                if (Object.keys(updatedOffersConsolidation).length > 0) {
                    const response = buildOffersResponse(updatedOffersConsolidation, selectedDates, selectedStation, selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig);
                    setOffersSummary(response);
                    resetDuplicateModalState();
                    setShowSubmitPopup(true);
                } else {
                    resetDuplicateModalState();
                    setShowSlotsSuccessModal(true);
                }
            }
            
        } catch (error) {
            console.error('Error processing duplicate resolutions:', error);
            alert('An error occurred while processing the resolutions. Please try again.');
        }
    };

    const handleSubmitRequest = async () => {
        // Check for duplicates using the existing data from props.offersTable
        const checkForDuplicates = () => {
            const duplicates = [];
            
            // Get all existing offers from the current props.offersTable
            const allExistingOffers = props.offersTable?.vtoOffers || [];
            
            if (allExistingOffers && allExistingOffers.length > 0) {
                Object.values(offersConsolidation).forEach(newOffer => {
                    const offerClassification = newOffer.classification || selectedClassification;
                    const offerDutyAssignment = newOffer.dutyAssignment || selectedDutyAssig;
                    const duplicateDates = [];
                    
                    // Check each selected date for duplicates
                    selectedDates.forEach(date => {
                        let newOfferString = `${date} ${newOffer.offerStartTimeHr}:${newOffer.offerStartTimeMin} - ${newOffer.offerEndTimeHr}:${newOffer.offerEndTimeMin} ${offerClassification} ${offerDutyAssignment}`;
                        
                        const matchingExistingOffer = allExistingOffers.find(existingOffer => {
                            let existingOfferString = `${existingOffer.offerStartDate} ${existingOffer.offerStartTime} - ${existingOffer.offerEndTime} ${existingOffer.classification} ${existingOffer.dutyAssignment}`;
                            return newOfferString === existingOfferString;
                        });
                        
                        if (matchingExistingOffer) {
                            duplicateDates.push({
                                date: date,
                                existingOffer: matchingExistingOffer
                            });
                        }
                    });
                    
                    if (duplicateDates.length > 0) {
                        duplicates.push({
                            newOffer: {
                                ...newOffer,
                                startTime: `${newOffer.offerStartTimeHr}:${newOffer.offerStartTimeMin}`,
                                endTime: `${newOffer.offerEndTimeHr}:${newOffer.offerEndTimeMin}`,
                                classification: offerClassification,
                                dutyAssignment: offerDutyAssignment
                            },
                            duplicateDates: duplicateDates,
                            nonDuplicateDates: selectedDates.filter(date => 
                                !duplicateDates.some(dup => dup.date === date)
                            )
                        });
                    }
                });
            }
            
            return duplicates;
        };

        // Check for duplicates using the existing data
        const duplicates = checkForDuplicates();
        if (duplicates.length > 0) {
            setDuplicateOffers(duplicates);
            const initialResolutions = {};
            duplicates.forEach((duplicate, offerIndex) => {
                initialResolutions[offerIndex] = {};
                duplicate.duplicateDates.forEach((duplicateDate, dateIndex) => {
                    initialResolutions[offerIndex][duplicateDate.date] = { 
                        action: null, 
                        additionalSlots: 1,
                        existingOffer: duplicateDate.existingOffer
                    };
                });
            });
            setDuplicateResolutions(initialResolutions);
            setShowDuplicateModal(true);
            return;
        }

        // Continue with submit if no duplicates
        proceedWithSubmit();
    };

    const proceedWithSubmit = () => {
        if (activeKey !== null && activeKey >= 0) {
            const hasError = hasSelectionError(activeKey);
            if (hasError || offersConsolidation[activeKey]?.error) {
                setShowError(true);
                setShowSubmitPopup(false);
                return;
            }
        }
        
        const { isValid, isRequiredFieldsSelected, isClassificationAndDutyValid } = validateFields(selectedDepartment, selectedDates, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll);
        if (!isValid) {
            setShowCDAError(true);
            return;
        }
        setShowCDAError(false);

        if (activeKey !== null && activeKey >= 0) {
            const currentOffer = offersConsolidation[activeKey];
            if ((!currentOffer.classification || !currentOffer.dutyAssignment)&& !isRequiredFieldsSelected) {
                setShowCDAError(true);
                let previousOffers = { ...offersConsolidation };
                let updatedOffer = { ...currentOffer, cdaError: true };
                previousOffers[activeKey] = updatedOffer;
                setOffersConsolidation(previousOffers);
                return;
            }
        }

        if (Object.values(offersConsolidation).some(offer => offer.error)) {
            setShowError(true);
            setShowSubmitPopup(false);
            return;
        }

        let response = buildOffersResponse(offersConsolidation, selectedDates, selectedStation, selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig);
        setOffersSummary(response);
        setShowSubmitPopup(true);
    };

    const handleConfirmationRequest = () =>{
        props.submitOffers(offersSummary);
        setSelectedDepartment("");
        setSelectedClassification("");
        setSelectedDutyAssig(""); 
    }

const todayStr = moment(stationTime).format('MM/DD/YYYY');
const availableDatesFiltered = isAfter2330(stationTime)
    ? availableDates.filter(date => date !== todayStr)
    : availableDates;

    useEffect(() => {
        if (selectedDates.length> 0 && dateShown !== selectedDates[0]) {
            setDateShown(selectedDates[0]);
        } 
    }, [selectedDates]);

    useEffect(() => {
        if (showRequiredFieldsError) {
            const { isValid } = validateFields(selectedDepartment, selectedDates, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll);
            setShowRequiredFieldsError(!isValid);
        }
        if (selectedClassification && selectedDutyAssig) {
            fillClassificationAndDutyA();
        }
        setIsFlashOffer(selectedDates.includes(moment().format("MM/DD/YYYY")));
    
        if (
            selectedDates.length > 0 &&
            selectedStation.length > 0 &&
            selectedDepartment.length > 0 
        ) {
            // Create search criteria for ALL selected dates instead of just dateShown
            const searchCriteria = [
                {
                    "queryOperator": "IN",
                    "searchField": "offerDate",
                    "value": "",
                    "values": selectedDates // Use all selected dates
                },
                {
                    "queryOperator": "EQUALS",
                    "searchField": "station",
                    "value": selectedStation
                }
            ];

            // Add classification and duty assignment if they're selected and apply all is checked
            if (selectedClassification && isCheckedApplyAll) {
                searchCriteria.push({
                    "queryOperator": "EQUALS",
                    "searchField": "classification",
                    "value": selectedClassification
                });
            }

            if (selectedDutyAssig && isCheckedApplyAll) {
                searchCriteria.push({
                    "queryOperator": "EQUALS",
                    "searchField": "dutyAssignment",
                    "value": selectedDutyAssig
                });
            }

            if (isCheckedApplyAll&&selectedDutyAssig&&selectedClassification) {
                setShowCDAError(false);
            }
    
            props.getOffersBatch( {
            "searchCriteria": searchCriteria,
            "sortBy": "offerStart", 
            "sortOrder": "ASC", 
            "pageNumber": 1, 
            "size": 500});
            if (Object.keys(offersConsolidation).length === 0) {
                handleAddNewOffer();
                setActiveKey("0");
            }
        }

        return () => {
            props.cleanUpBatch()}
    }, [
        selectedClassification,
        selectedDutyAssig,
        selectedStation,
        selectedDepartment,
        isCheckedApplyAll,
        selectedDates // Change from dateShown to selectedDates
    ]);

    useEffect(()=>{
        !props.stationList || props.stationList?.length === 0  ?  props.getStationList(props.userId) : setStationOptions(props.stationList);
        stationOptions?.length == 0 && setSelectedStation("");
        if (props.stationList.length == 0) {
            setIsStationError(true);
        } else {
            setIsStationError(false);
        }
    }, [props.stationList])

    useEffect(() => {
        if (typeof props.stationListSuccess == 'boolean') {
            !props.stationListSuccess ? setIsStationError(true) : setIsStationError(false);
        }
    },[props.stationListSuccess])

    useEffect(() => {
        const fetchStationTime = async () => {
            if (selectedStation) {
                let stationTime = await getStationTimestamp(selectedStation.toUpperCase());
                setStationTime(stationTime);
            }
        };
        const activeOffer = offersConsolidation[activeKey];
        if (activeOffer && (activeOffer.offerStartTimeHr || activeOffer.offerStartTimeMin)) {
            fetchStationTime();
        }
    }, [offersConsolidation[activeKey]?.offerStartTimeHr, offersConsolidation[activeKey]?.offerStartTimeMin, selectedStation]);

    useEffect(() => {
        if (typeof props.slotsUpdateSuccess == "boolean") {
            if (props.slotsUpdateSuccess) {
                const updatedDuplicates = duplicateOffers.filter(duplicate => 
                    duplicate.existingOffer.offerId !== selectedOfferForSlots?.offerId
                );
                setDuplicateOffers(updatedDuplicates);
                const offersToRemove = duplicateOffers.filter(duplicate => 
                    duplicate.existingOffer.offerId === selectedOfferForSlots?.offerId
                );
                let updatedOffersConsolidation = { ...offersConsolidation };
                offersToRemove.forEach(duplicateToRemove => {
                    const idToRemove = duplicateToRemove.newOffer.id;
                    delete updatedOffersConsolidation[idToRemove];
                });
                setOffersConsolidation(updatedOffersConsolidation);
                const remainingOfferCount = Object.keys(updatedOffersConsolidation).length;
                if (remainingOfferCount > 0) {
                    let response = buildOffersResponse(updatedOffersConsolidation, selectedDates, selectedStation, selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig);
                    setOffersSummary(response);
                    setShowSubmitPopup(true);
                } else {
                    setShowSlotsSuccessModal(true);
                }
                if (selectedStation && selectedDepartment && selectedDates.length > 0) {
                    const searchCriteria = createSearchCriteria(dateShown, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll);
                    props.getOffersBatch({
                        "searchCriteria": searchCriteria,
                        "sortBy": "offerStart",
                        "sortOrder": "ASC",
                        "pageNumber": 1,
                        "size": 500
                    });
                }
            } else if (props.slotsUpdateSuccess === false) {
                alert(`${props.slotsUpdateError?.title || 'Error updating slots'} ${props.slotsUpdateError?.detail || 'Please try again.'}`);
            }
            props.resetSlotsUpdateSuccess();
        }
    }, [props.slotsUpdateSuccess, props.slotsUpdateError, selectedStation, selectedDepartment, selectedDates, dateShown, duplicateOffers, offersConsolidation, selectedOfferForSlots, selectedClassification, selectedDutyAssig]);

    return (
        <div style={{marginLeft: 50, marginRight: 50}}>
          {showSubmitPopup && <ConfirmationPopUp
                title={"Offers Summary"}
                headers={["", "", "Offer", "Duration", "Slots", "Classification", "Duty Assignment", "Cut Off Time"]}
                showModal={showSubmitPopup}
                selectedList={offersSummary.offers || []}
                availableDates={availableDates}
                handleConfirmationRequest={(state)=>handleConfirmationRequest(state)}
                setShowModal={(state)=>setShowSubmitPopup(state)}
                showConfirmationLoader={props.showConfirmationLoader}
                confirmedBatch={props.confirmedBatch}
                showConfirmData={props.showConfirmData}
                batchSubmitted={props.batchSubmitted}
                cleanUpBatch={()=>{
                    setOffersConsolidation({})
                    props.cleanUpBatch()}}
            />}
            
            <DuplicateOfferModal
                showDuplicateModal={showDuplicateModal}
                duplicateOffers={duplicateOffers}
                duplicateResolutions={duplicateResolutions}
                setDuplicateResolutions={setDuplicateResolutions}
                handleConfirmDuplicateResolutions={handleConfirmDuplicateResolutions}
                setShowDuplicateModal={setShowDuplicateModal}
                setDuplicateOffers={setDuplicateOffers}
            />

            <SlotsSuccessModal
                showSlotsSuccessModal={showSlotsSuccessModal}
                setShowSlotsSuccessModal={setShowSlotsSuccessModal}
                setSelectedOfferForSlots={setSelectedOfferForSlots}
                setDuplicateOffers={setDuplicateOffers}
                history={history}
            />
             <a
            style={{cursor: 'pointer'}}
              onClick={() => {
                history.goBack()
              }}
            >&gt;{strings.backButton}</a>
            <div style={{marginLeft: 20}}>
            <div style={{display:'flex'}}>
            <div>
                <div className="subtitle" style={{marginTop: 20}}>
                    Create New VTO Offer
                </div>

                <div>
                    <div className="button-container">
                    {availableDates.map(date => (
                        <Button key={date}
                            className={`button-regular dates ${selectedDates.includes(date) && "selected"}`}
                            data-value={date}
                            style={{ marginTop: 30 }}
                            onClick={() => handleSelectDate(date)}
                            disabled={isAfter2330(stationTime) && date === todayStr}
                        > {date}
                        </Button>
                    ))}
                    </div>
                    {isAfter2330(stationTime) ? (
                    <div style={{ display: 'flex', marginTop: 20 }}>
                        <p className="note" style={{ margin: 0, marginLeft: 5, color: 'red' }}>
                            *You can't create a flash offer for today
                        </p>
                    </div>
                    ) : (
                    isFlashOffer &&
                    <div style={{ display: 'flex', marginTop: 20 }}>
                        <img src={flashIcon} />
                        <p className="note" style={{ margin: 0, marginLeft: 5 }}>
                            Flash offers will be created for {todayStr}
                        </p>
                    </div>
                    )}
                    <div className="dropdown-form" style={{display: "flex", flexWrap: "wrap"}}>
                        <div className="flex-column-wrap-gap">
                            <DropdownSelect
                            title={"Station"}
                            options={stationOptions}
                            selectedOption={selectedStation}
                            setSelectedOption={(state)=>handleSelectStation(state)}
                            isRequired={true}
                            isEnabled={!isStationError}
                            error={(showCDAError&&!selectedStation) || isStationError}
                            />
                            {isStationError && <p className="error" style={{color: "red"}}>*No stations available. Please try again later.</p>}
                        </div>
                        <DropdownSelect
                        title={"Department"}
                        options={departmentOptions}
                        selectedOption={selectedDepartment}
                        setSelectedOption={(state)=>handleSelectDepartment(state)}
                        isRequired={true}
                        isEnabled={selectedStation.length>0}
                        error={showCDAError&&!selectedDepartment}
                        />

                        {/* <DropdownSelect
                        title={groupTitle? groupTitle : "Group" }
                        options={groupOptions}
                        selectedOption={selectedGroup}
                        setSelectedOption={(state)=>handleSelectGroup(state)}
                        isRequired={true}
                        isEnabled={selectedDepartment}
                        /> */}

                        {/* <DropdownSelect
                        title={"Work Location"}
                        options={workLocOptions}
                        selectedOption={selectedWorkLoc}
                        setSelectedOption={(state)=>setSelectedWorkLoc(state)}
                        isRequired={false}
                        isEnabled={selectedDepartment.length> 0} 
                        />
                        */}
                    </div>
                    <div className="dropdown-form" style={{display: "flex", flexWrap: "wrap", marginTop: 30}}>
                        <DropdownSelect
                        title={"Classification"}
                        options={classificationOptions}
                        selectedOption={selectedClassification}
                        setSelectedOption={(state)=>setSelectedClassification(state)}
                        isRequired={true}
                        isEnabled={isCheckedApplyAll}
                        error={isCheckedApplyAll&&!selectedClassification&&showCDAError}
                        />

                        <DropdownSelect
                        title={"Duty Assignment"}
                        options={dutyAssigOptions}
                        selectedOption={selectedDutyAssig}
                        setSelectedOption={(state)=>setSelectedDutyAssig(state)}
                        isRequired={true}
                        isEnabled={isCheckedApplyAll}
                        error={isCheckedApplyAll&&!selectedDutyAssig&&showCDAError}
                        />

                    </div>
                    <div className="flex-nowrap-center-ml" onClick={handleApplyAllChange}>
                        <input onChange={handleApplyAllChange} type="checkbox" checked={isCheckedApplyAll} />
                        <p className="note" style={{margin: 0, marginLeft: 10,color:!isCheckedApplyAll&&"#0000002d"}} >Apply Classification and Duty Assignment to all offers.</p>
                    </div>
                    {!isCheckedApplyAll&&<div style={{display: "flex",alignItems:'center',}}>
                        <img src={infoIcon}/><p className="note" style={{margin: 0, }}>Classification and Duty Assignment are required and will need to be selected within each offer.</p>
                    </div>}
                </div>
            </div>
            {/* {props.offersTable && props.offersTable.vtoOffers?.length> 0 && selectedDates.length>0 && selectedDepartment.length>0 && selectedStation.length>0 && */}
              <CurrentOffers
              offersBatch={props.offersTable}
              selectedDates={selectedDates}
              dateShown={dateShown}
              setDateShown={(state)=>setDateShown(state)}
              selectedDepartment={selectedDepartment}
              selectedStation={selectedStation}
              offersFound={props.offersTable.offersFound}/>
            </div>
            {Object.keys(offersConsolidation).length>0 &&
                <div>
                    <Accordion style={{marginTop: 40}} defaultActiveKey="0" activeKey={activeKey}>
                    {Object.values(offersConsolidation).map((offer,idx)=>{
                    const headerStyle = offer.error ? { border: '2px solid red', borderRadius: 10 } : {};
                    return (
                    <div key={idx} className="offer-header">
                        <div style={headerStyle}>
                            <NewOfferComponent
                                handleDeleteOffer={(state)=>handleDeleteOffer(state)}
                                idx={idx}
                                id={offer.id}
                                offerDetailsSelected={offer}
                                offersConsolidation={offersConsolidation}
                                setOffersConsolidation={(state)=>setOffersConsolidation(state)}
                                setOfferDetails={(state)=>setOfferDetails(state)}
                                activeKey={activeKey}
                                setActiveKey={(state)=>setActiveKey(state)}
                                handleClickHeader={(state)=>handleClickHeader(state)}
                                showError={offer.error}
                                setShowError={(state)=>setShowError(state)}
                                hasSelectionError={(state)=>hasSelectionError(state)}
                                handleAddNewOffer={(state)=>handleAddNewOffer(state)}
                                isFlashOffer={isFlashOffer}
                                isCheckedApplyAll={isCheckedApplyAll}
                                classificationOptions={classificationOptions}
                                dutyAssigOptions={dutyAssigOptions}
                                setShowCDAError={(state)=>setShowCDAError(state)}
                                selectedClassification={selectedClassification}
                                selectedDutyAssig={selectedDutyAssig}
                                selectedDates={selectedDates}
                                availableDates={availableDates}
                                setCutOffTime={(state)=>setCutOffTime(state)}
                                validateOfferTimes={(startTime, endTime, selectedDate)=>validateOfferTimes(startTime, endTime, selectedDate, stationTime)}
                                stationTime={stationTime}
                            />
                        </div>
                    </div>
                    );
                    })}
                    </Accordion>
                </div>
                }
                <div style={{display: "flex", flexDirection: "column", alignItems: 'flex-start'}}>
                    <button className={`addoffer-title ${showError ? "disabled" : ""}`} 
                    disabled={showError}
                    onClick={()=>{
                        const { isValid } = validateFields(selectedDepartment, selectedDates, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll);
                        if (!isValid) {
                            setShowRequiredFieldsError(true);
                            setShowCDAError(true);
                            return;
                        }
                        setShowRequiredFieldsError(false);
                        setShowCDAError(false);
                        handleAddNewOffer(offerDetails);
                    }}
                        >
                        + Add new offer {showRequiredFieldsError? 
                        selectedDates.length> 0 ? <p style={{color: "#D20000"}}>*Select Required fields</p>
                    : <p style={{color: "red"}}>*Select Dates</p> : null }
                    </button>
                    <div style={{display: 'flex'}}>
                        <Button  variant="primary" 
                            disabled={Object.keys(offersConsolidation).length== 0 || Object.values(offersConsolidation).some(offer => offer.error) || showRequiredFieldsError || showCDAError} 
                            onClick={handleSubmitRequest}
                            className={`button-regular cancel ${(Object.keys(offersConsolidation).length== 0 || Object.values(offersConsolidation).some(offer => offer.error)) &&"disabled"}`}
                            style={{marginBottom: 50}}
                            > Submit
                        </Button>
                        {(showRequiredFieldsError || showCDAError)&&<p className="error" style={{color: "#D20000"}}>*Select Required fields</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    stationCode: state.AuthenticationReducer.station,
    userId: state.AuthenticationReducer.userId,
    firstName: state.AuthenticationReducer.firstName,
    lastName: state.AuthenticationReducer.lastName,
    offersTable: state.VTOReducer.offersTable,
    stationList: state.VTOReducer.stationList,
    batchSubmitted: state.VTOReducer.batchSubmitted,
    confirmedBatch: state.VTOReducer.confirmedBatch,
    showConfirmData: state.VTOReducer.showConfirmData,
    showConfirmationLoader: state.VTOReducer.showSearchLoader,
    stationList: state.VTOReducer.stationList,
    stationListSuccess: state.VTOReducer.stationListSuccess,
    slotsUpdateSuccess: state.VTOReducer.slotsUpdateSuccess,
    slotsUpdateError: state.VTOReducer.slotsUpdateError,
});

const mapDispatchToProps = (dispatch) => ({ 
    getOffersBatch: (params) => 
            dispatch({ type: vtoConstants.OFFERS_TABLE_BATCH, params: params}),
    getStationList: (params ) => {
        dispatch({ type: vtoConstants.GET_VTO_STATION_LIST, params: params})},
    cleanUpBatch: (params) =>
        dispatch({type: vtoConstants.CLEAN_UP, params: true}),
    submitOffers: (params) => {
        dispatch({ type: vtoConstants.SUBMIT_OFFERS_BATCH, params: params})
    },
    updateSlotsRequest: (params) =>
        dispatch({ type: vtoConstants.UPDATE_SLOTS, params: params}),
    resetSlotsUpdateSuccess: () =>
        dispatch({ type: vtoConstants.UPDATE_SLOTS_SUCCESS, params: {data: null}}),
});

export default connect (mapStateToProps, mapDispatchToProps) (CreateOfferscreen);
